import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex align-center primary--text" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "d-flex align-center primary--text" }
const _hoisted_4 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_OssDialog = _resolveComponent("OssDialog")!
  const _component_EditCompany = _resolveComponent("EditCompany")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pb-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "pb-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                disabled: _ctx.disabledWrite,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogSelectAccountingFirm = !_ctx.dialogSelectAccountingFirm)),
                variant: "flat"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Ajouter ")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "pl-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                label: "Recherche",
                "hide-details": "",
                density: "compact",
                "append-inner-icon": "$search"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "1",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_trash, {
                onClick: _ctx.initialize,
                class: "mx-2",
                size: "small"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.accountingFirms.length)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "d-flex justify-center",
            style: {"max-height":"84vh","overflow-y":"auto"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childAccountingFirms, (accFirm) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  cols: _ctx.isMobile ? 12 : 8,
                  class: "my-0 pa-2",
                  key: accFirm.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "default_card ma-0 pa-0",
                      elevation: "0",
                      style: {"margin":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          class: "d-flex align-center",
                          onClick: ($event: any) => (_ctx.openAccountingFirm(accFirm.id))
                        }, {
                          default: _withCtx(() => [
                            (!_ctx.isMobile)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      color: "secondary",
                                      size: "large",
                                      class: "icon"
                                    }, {
                                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                                        _createTextVNode(" $apartment ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_col, {
                              cols: _ctx.isMobile ? 10 : 8
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(_ctx.isMobile ? 'ml-2' : ''),
                                    style: {"font-weight":"bold","font-size":"16pt"}
                                  }, _toDisplayString(accFirm.name), 3)
                                ]),
                                _createElementVNode("div", _hoisted_2, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(_ctx.isMobile ? 'ml-2' : '')
                                  }, " SIRET: " + _toDisplayString(_ctx.getSiretValue(accFirm.siret)), 3)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["cols"]),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "d-flex justify-space-around align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  icon: "$oss-edit",
                                  color: "secondary",
                                  elevation: "0",
                                  size: "small"
                                }),
                                _createVNode(_component_v_btn, {
                                  icon: "$oss-disconnect",
                                  color: "#f76631",
                                  elevation: "0",
                                  disabled: _ctx.disabledWrite,
                                  onClick: _withModifiers(($event: any) => {
                                    _ctx.selectedAccountingFirm = accFirm;
                                    _ctx.dialogDisconnectAccountingFirm = true;
                                }, ["stop"]),
                                  size: "small"
                                }, null, 8, ["disabled", "onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["cols"]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: _ctx.isMobile ? 12 : 6,
                class: "my-0 pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "default_card ma-0 pa-0",
                    elevation: "0",
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "d-flex align-center" }, {
                        default: _withCtx(() => [
                          (!_ctx.isMobile)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    color: "error",
                                    size: "large",
                                    class: "icon"
                                  }, {
                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                      _createTextVNode(" $apartment ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_col, {
                            cols: _ctx.isMobile ? 10 : 8
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.isMobile ? 'ml-2' : ''),
                                  style: {"font-weight":"bold","font-size":"16pt"}
                                }, " Aucun sous cabinet ", 2)
                              ]),
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.isMobile ? 'ml-2' : '')
                                }, " Vous n'avez enregistré aucun sous cabinet ", 2)
                              ])
                            ]),
                            _: 1
                          }, 8, ["cols"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["cols"])
            ]),
            _: 1
          })),
      _createElementVNode("template", null, [
        (_ctx.dialogSelectAccountingFirm)
          ? (_openBlock(), _createBlock(_component_OssDialog, {
              key: 0,
              modelValue: _ctx.dialogSelectAccountingFirm,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogSelectAccountingFirm) = $event)),
              title: 'Ajouter un cabinet',
              width: "1000px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CompaniesTable, {
                  "client-company": false,
                  "accounting-firm-company": true,
                  "show-generic-company": false,
                  "show-new-companies": true,
                  "show-existing-companies": false,
                  accountingFirmId: _ctx.accountingFirm.id,
                  onSelectCompany: _ctx.accountingFirmSelected,
                  "wizard-mode": true,
                  "is-enable-accounting-firms": true,
                  "can-select-companies-with-accounting-company": true
                }, null, 8, ["accountingFirmId", "onSelectCompany"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_OssDialog, {
          modelValue: _ctx.dialogDisconnectAccountingFirm,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogDisconnectAccountingFirm) = $event)),
          "max-width": _ctx.isMobile ? undefined : '650px',
          fullscreen: _ctx.isMobile,
          "hide-overlay": _ctx.isMobile,
          title: "Enlever la société cliente",
          "valid-title": "Retirer",
          onValid: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteAccountingFirm(_ctx.selectedAccountingFirm)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "mx-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _cache[10] || (_cache[10] = _createTextVNode(" Vous êtes sur le point de retirer le cabinet ")),
                    _createElementVNode("b", null, _toDisplayString(_ctx.selectedAccountingFirm.name), 1),
                    _cache[11] || (_cache[11] = _createTextVNode(" de vos sous cabinet. Confirmer le retrait ? "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay"]),
        _createVNode(_component_OssDialog, {
          modelValue: _ctx.newAccountingFirmDialog,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newAccountingFirmDialog) = $event)),
          "max-width": _ctx.isMobile ? undefined : '80%',
          fullscreen: _ctx.isMobile,
          "hide-overlay": _ctx.isMobile,
          actions: _ctx.actions,
          title: "Création / Edition du cabinet"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_EditCompany, {
              "settings-mode": true,
              "admin-mode": true,
              "in-company": _ctx.newAccountingFirm,
              actions: _ctx.actions,
              onUpdated: _cache[5] || (_cache[5] = ($event: any) => (_ctx.accountingFirmSelected($event)))
            }, null, 8, ["in-company", "actions"])
          ]),
          _: 1
        }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay", "actions"])
      ])
    ]),
    _: 1
  }))
}